import { GaPageType, L2Category, L3Category } from '../../types/advertising/partnership';
import { L1Category } from '../../types/client-data';

const activeAnyvanCategories = [
    { l1: 'for-sale', l2: 'stereos-audio', l3: 'home-cinema' },
    { l1: 'for-sale', l2: 'baby-kids-stuff', l3: 'nursery-childrens-furniture' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'building-materials' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'doors-windows' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'garden-hand-tools' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'garden-power-tools' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'hand-tools' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'power-tools' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'ladders-handtrucks' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'plumbing-central-heating' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'protective-workwear' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'screws-fixings' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'wood-timber' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'tool-storage-workbenches' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'bathroom-fixtures' },
    { l1: 'for-sale', l2: 'diy-tools-materials', l3: 'baths' },
    { l1: 'for-sale', l2: 'freebies' },
    { l1: 'for-sale', l2: 'health-beauty', l3: 'mobility-disability-medical' },
    { l1: 'for-sale', l2: 'home-garden', l3: 'beds-bedroom-furniture' },
    { l1: 'for-sale', l2: 'home-garden', l3: 'dining-living-room-furniture' },
    { l1: 'for-sale', l2: 'home-garden', l3: 'gardening-patio-furniture' },
    { l1: 'for-sale', l2: 'home-garden', l3: 'other-household-goods' },
    { l1: 'for-sale', l2: 'house-clearance' },
    { l1: 'for-sale', l2: 'miscellaneous-goods', l3: 'antiques' },
    { l1: 'for-sale', l2: 'miscellaneous-goods', l3: 'aquariums-for-sale' },
    { l1: 'for-sale', l2: 'miscellaneous-goods', l3: 'art-for-sale' },
    { l1: 'for-sale', l2: 'miscellaneous-goods', l3: 'other-miscellaneous-goods' },
    { l1: 'for-sale', l2: 'miscellaneous-goods', l3: 'pottery-porcelain-glass-for-sale' },
    { l1: 'for-sale', l2: 'miscellaneous-goods', l3: 'tools' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'guitars' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'keyboards-pianos' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'other-instruments' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'percussion-drums' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'sheet-music' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'string-instruments' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'studio-live-music-equipment' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'woodwind-brass-instruments' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'decks-dj-accessories' },
    { l1: 'for-sale', l2: 'music-instruments', l3: 'brass-musical-instruments' },
    { l1: 'for-sale', l2: 'office-furniture-equipment', l3: 'business-for-sale' },
    { l1: 'for-sale', l2: 'office-furniture-equipment', l3: 'retail-shop-fitting' },
    { l1: 'for-sale', l2: 'office-furniture-equipment', l3: 'medical-laboratory-equipment' },
    { l1: 'for-sale', l2: 'office-furniture-equipment', l3: 'restaurant-catering-equipment' },
    { l1: 'for-sale', l2: 'office-furniture-equipment', l3: 'packaging-mailing-supplies' },
    {
        l1: 'for-sale',
        l2: 'office-furniture-equipment',
        l3: 'office-supplies-equipment-stationary',
    },
    { l1: 'for-sale', l2: 'office-furniture-equipment', l3: 'office-furniture' },
    { l1: 'for-sale', l2: 'other-stuff-for-sale' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'bicycle-accessories' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'bicycles' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'boys-bikes-for-sale' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'camping-hiking' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'fishing-equipment' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'girls-bikes-for-sale' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'gym-equipment' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'gym-memberships' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'luggage-travel-equipment' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'other-sports-leisure' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'water-sports' },
    { l1: 'for-sale', l2: 'sports-leisure-travel', l3: 'winter-sports' },
    { l1: 'for-sale', l2: 'stuff-wanted', l3: 'household-stuff-wanted' },
    { l1: 'for-sale', l2: 'stuff-wanted', l3: 'miscellaneous-stuff-wanted' },
    { l1: 'for-sale', l2: 'stuff-wanted', l3: 'other-stuff-wanted' },
    { l1: 'for-sale', l2: 'stuff-wanted', l3: 'sports-leisure-stuff-wanted' },
    { l1: 'for-sale', l2: 'stuff-wanted', l3: 'tickets-stuff-wanted' },
    { l1: 'for-sale', l2: 'stuff-wanted', l3: 'transport-stuff-wanted' },
    { l1: 'for-sale', l2: 'swap-shop' },
    { l1: 'for-sale', l2: 'tv-dvd-cameras', l3: 'televisions-plasma-lcd-tvs' },
    { l1: 'for-sale', l2: 'cameras-studio-equipment', l3: 'lighting-studio' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'dishwashers' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'freezers' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'other-kitchen-appliances' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'ovens-hobs-cookers' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'refrigerators' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'small-appliances-for-sale' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'taps-units-worktops-for-sale' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'tumble-dryers' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'washing-machines' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'integrated-appliances' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'fridges-freezers' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'washer-dryers' },
    { l1: 'for-sale', l2: 'kitchen-appliances', l3: 'home-appliances' },
    { l1: 'for-sale', l2: 'christmas-decorations' },
    { l1: 'flats-houses', l2: 'flats-and-houses-for-rent', l3: 'flats-and-house-for-rent-wanted' },
    {
        l1: 'flats-houses',
        l2: 'flats-and-houses-for-rent',
        l3: 'flats-and-houses-for-rent-offered',
    },
    { l1: 'flats-houses', l2: 'flats-and-houses-for-rent', l3: 'holiday-rentals-deprecated' },
    { l1: 'flats-houses', l2: 'flats-and-houses-for-rent', l3: 'office-space' },
    { l1: 'flats-houses', l2: 'flats-and-houses-for-rent', l3: 'parking-garage' },
    { l1: 'flats-houses', l2: 'flatshare', l3: 'flatshare-offered' },
    { l1: 'flats-houses', l2: 'flatshare', l3: 'flatshare-wanted' },
    {
        l1: 'flats-houses',
        l2: 'property-for-sale-deprecated',
        l3: 'international-property-for-sale-deprecated',
    },
    { l1: 'flats-houses', l2: 'property-for-sale-deprecated', l3: 'local-property-for-sale' },
    { l1: 'flats-houses', l2: 'property-for-sale-deprecated', l3: 'houses-for-sale' },
    { l1: 'flats-houses', l2: 'property-for-sale-deprecated', l3: 'flats-for-sale' },
    { l1: 'flats-houses', l2: 'property-for-sale-deprecated', l3: 'new-homes-for-sale' },
    {
        l1: 'flats-houses',
        l2: 'property-for-sale-deprecated',
        l3: 'commercial-property-for-sale-old',
    },
    { l1: 'flats-houses', l2: 'land-farms-estates-for-sale', l3: 'farm-estates-for-sale' },
    { l1: 'flats-houses', l2: 'land-farms-estates-for-sale', l3: 'land-for-sale' },
    { l1: 'flats-houses', l2: 'land-farms-estates-for-sale', l3: 'equestrian-for-sale' },
    { l1: 'flats-houses', l2: 'land-farms-estates-for-sale', l3: 'country-houses-for-sale' },
    { l1: 'flats-houses', l2: 'land-farms-estates-for-sale', l3: 'woodland-for-sale' },
    { l1: 'flats-houses', l2: 'land-farms-estates-for-sale', l3: 'rural-business-for-sale' },
    { l1: 'flats-houses', l2: 'commercial', l3: 'commercial-property-for-sale' },
    { l1: 'flats-houses', l2: 'commercial', l3: 'commercial-property-to-rent' },
    { l1: 'flats-houses', l2: 'property-wanted' },
    { l1: 'flats-houses', l2: 'holiday-rentals' },
    { l1: 'flats-houses', l2: 'international-property-for-sale' },
    { l1: 'flats-houses', l2: 'garage-parking', l3: 'garage-parking-for-sale' },
    { l1: 'flats-houses', l2: 'garage-parking', l3: 'garage-parking-to-rent' },
    { l1: 'flats-houses', l2: 'property-to-rent' },
    { l1: 'flats-houses', l2: 'property-for-sale' },
    { l1: 'flats-houses', l2: 'property-to-share' },
    { l1: 'flats-houses', l2: 'home-swap' },
];

export const isAnyvanEnabled = (
    gaPageType: GaPageType,
    l1Category: L1Category | undefined,
    l2Category: L2Category,
    l3Category: L3Category | undefined
): boolean => {
    if (gaPageType !== 'VIP') {
        return false;
    }

    return activeAnyvanCategories.some(
        (activeCategory) =>
            activeCategory.l1 === l1Category &&
            activeCategory.l2 === l2Category &&
            activeCategory.l3 === l3Category
    );
};
